import { Stack, StackItem } from '@fluentui/react';
import { Text, FluentProvider, webLightTheme, Card, Divider, Title3, SkeletonItem } from '@fluentui/react-components';
import { homeImage, skeleton1, skeleton2, skeleton3, parentHome, childHome, dividerStyle, skeleton7, cardBorder, skeletonQuicklink, homeCardResponsive, skeleton4, skeleton6, skeleton5, skeleton9, quickLinkHeight, inlineSideMenu, } from '../../styles/customStyles';

export const SkeletonHome = (props: any) => {
  return (
    <>
      <FluentProvider theme={webLightTheme} style={parentHome}>
        {/* <Stack tokens={{padding:15}}> <Title3> Nanoheal </Title3> </Stack> */}
        <Stack tokens={{ childrenGap: 10, padding: '20px' }} horizontalAlign="center" horizontal style={homeCardResponsive}>
          <Card size='large' style={{ ...homeImage, overflow: 'auto', ...inlineSideMenu }}>
            <Stack tokens={{ childrenGap: 10, padding: 10 }} verticalAlign="space-between">
              <StackItem>
                <Stack tokens={{ childrenGap: 15 }}>
                  <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                      <StackItem grow shrink>
                        <Stack horizontalAlign="start"> <StackItem> <SkeletonItem size={36} style={skeleton1} /> </StackItem> </Stack>
                      </StackItem>
                      <StackItem grow shrink>
                        {/* <Stack horizontalAlign="end"> <StackItem> <SkeletonItem size={36} style={skeleton2}/> </StackItem></Stack> */}
                      </StackItem>
                    </Stack>
                  </StackItem>
                  <StackItem> <SkeletonItem size={32} style={skeleton7} /> </StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                      <StackItem> <SkeletonItem size={28} style={skeleton3} /> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </StackItem>

              {/* status and spotlight */}
              <Stack style={{ marginTop: "0px", ...inlineSideMenu }} horizontal horizontalAlign='end'>
                <StackItem style={{ width: '45%' }}>
                  <StackItem> <SkeletonItem size={24} style={skeleton6} /> </StackItem>
                </StackItem>
              </Stack>
              <Stack style={inlineSideMenu} horizontal tokens={{ childrenGap: 10 }} horizontalAlign="space-between">
                <StackItem style={inlineSideMenu}>
                  <Stack tokens={{ childrenGap: 10 }}>
                    <Card style={cardBorder}>
                      <Stack> <StackItem> <SkeletonItem size={24} style={skeleton5} /> </StackItem> </Stack>
                      <Stack tokens={{ childrenGap: 20 }} horizontal>
                        <StackItem grow shrink>
                          <Stack tokens={{ childrenGap: 10, padding: 12 }} horizontal>
                            <StackItem grow shrink>
                              <Stack horizontalAlign="start">
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem><Stack horizontal style={dividerStyle}><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 2 }}>
                                            <StackItem> <SkeletonItem size={20} style={skeleton9} /> </StackItem>
                                            <StackItem> <SkeletonItem size={20} style={skeleton5} /> </StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem><Stack horizontal style={dividerStyle}><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 2 }}>
                                            <StackItem> <SkeletonItem size={20} style={skeleton9} /> </StackItem>
                                            <StackItem> <SkeletonItem size={20} style={skeleton5} /> </StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem><Stack horizontal style={dividerStyle}><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 2 }}>
                                            <StackItem> <SkeletonItem size={20} style={skeleton9} /> </StackItem>
                                            <StackItem> <SkeletonItem size={20} style={skeleton5} /> </StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem grow shrink>
                              <Stack horizontalAlign="start">
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem><Stack horizontal style={dividerStyle}><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 2 }}>
                                            <StackItem> <SkeletonItem size={20} style={skeleton9} /> </StackItem>
                                            <StackItem> <SkeletonItem size={20} style={skeleton5} /> </StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem><Stack horizontal style={dividerStyle}><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 2 }}>
                                            <StackItem> <SkeletonItem size={20} style={skeleton9} /> </StackItem>
                                            <StackItem> <SkeletonItem size={20} style={skeleton5} /> </StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Card>
                    <Card style={cardBorder}>
                      <Stack> <StackItem> <SkeletonItem size={24} style={skeleton4} /> </StackItem> </Stack>
                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem grow shrink>
                              <Stack horizontalAlign="start">
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <StackItem> <SkeletonItem size={24} style={skeleton6} /> </StackItem>
                                    <StackItem> <SkeletonItem size={96} style={skeleton9} /> </StackItem>
                                    <StackItem> <SkeletonItem shape='rectangle' size={24} style={skeleton4} /> </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <StackItem><Stack horizontal style={dividerStyle} horizontalAlign="center"><Divider vertical /><Divider vertical /><Divider vertical /></Stack></StackItem>
                            <StackItem grow shrink>
                              <Stack horizontalAlign="start">
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <StackItem> <SkeletonItem size={24} style={skeleton6} /> </StackItem>
                                    <StackItem> <SkeletonItem size={96} style={skeleton9} /> </StackItem>
                                    <StackItem> <SkeletonItem shape='rectangle' size={24} style={skeleton4} /> </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Card>
                  </Stack>
                </StackItem>

                {/* Quicklinks */}
                <StackItem style={parentHome}>
                  {/* <Card> */}
                  <Stack style={parentHome} tokens={{ childrenGap: 10, padding: '0px 0px 0px 0px' }}>
                    <Card style={{ ...cardBorder, ...parentHome }}>
                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem> <SkeletonItem size={72} shape="circle" /> </StackItem>
                        <StackItem>
                          <Stack tokens={{ childrenGap: 5 }}>
                            <StackItem> <SkeletonItem size={20} style={skeleton6} /> </StackItem>
                            <StackItem> <SkeletonItem size={72} style={skeletonQuicklink} /> </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Card>
                    <Card style={{ ...cardBorder, ...parentHome }}>
                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem> <SkeletonItem size={72} shape="circle" /> </StackItem>
                        <StackItem>
                          <Stack tokens={{ childrenGap: 5 }}>
                            <StackItem> <SkeletonItem size={20} style={skeleton6} /> </StackItem>
                            <StackItem> <SkeletonItem size={72} style={skeletonQuicklink} /> </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Card>
                    <Card style={{ ...cardBorder, ...parentHome }}>
                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem> <SkeletonItem size={72} shape="circle" /> </StackItem>
                        <StackItem>
                          <Stack tokens={{ childrenGap: 5 }}>
                            <StackItem> <SkeletonItem size={20} style={skeleton6} /> </StackItem>
                            <StackItem> <SkeletonItem size={72} style={skeletonQuicklink} /> </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Card>
                  </Stack>
                  {/* </Card> */}
                </StackItem>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Card size="small" appearance="subtle" style={{ width: '98.9vw' }} />
      </FluentProvider>
    </>
  );
};
